// removed by extract-text-webpack-plugin
module.exports = {"copyright":"Copyright-module__copyright___1iHCC"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Footer/Copyright.module.scss
// module id = 252
// module chunks = 0 1